import type { Lesson, LessonSlots } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonShowApiOptions {
  disciplineId: string | number
  lessonId: string | number
}

interface LessonShowData {
  lesson: Lesson | null
  slots: LessonSlots | null
}

/** There is no single-lesson read: the discipline's list narrowed by `booking_id` returns that lesson, with the
 *  booking slots the edit form offers. `lesson` is null for a lesson of another discipline. */
export const useLessonShowApi = async (options: LessonShowApiOptions): Promise<LessonShowData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.index', {
    discipline_id: options.disciplineId,
    booking_id: options.lessonId,
    per_page: 1,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)
    const lessons: Lesson[] = data.data?.lessons ?? []

    return {
      lesson: lessons.find(lesson => String(lesson.id) === String(options.lessonId)) ?? null,
      slots: data.data?.booking_slots ?? null,
    }
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return null
  }
}
